// Add new department
export const API_ADD_NEW_DEPARTMENT_URL: string = 'http://localhost:8082/department/add-new'

export type APIAddNewDepartmentTypes = {
    accessToken: string;
    organizationName: string;
    shortName: string;
    email: string;
    faxNumber: string;
    departmentName: string;
    address: string;
    telephoneNumber: string;
}

// Get all departments
export const API_GET_ALL_DEPARTMENT_URL: string = 'http://localhost:8082/department/get-all'

export type APIGetAllDepartmentDataResponseType = {
    id: string;
    address: string;
    email: string;
    faxNumber: string;
    name: string;
    organizationName: string;
    shortName: string;
    telephone: string;
}

// Get department by value
export const API_GET_DEPARTMENT_BY_VALUE_URL: string = 'http://localhost:8082/department/get-department'

export type APIGetDepartmentByValueType = {
    value: string;
}

// Update department
export const API_UPDATE_DEPARTMENT_URL: string = 'http://localhost:8082/department/update'

export type APIUpdateDepartmentType = {
    accessToken: string;
    id: string;
    organizationName: string;
    //shortName: string;
    email: string;
    faxNumber: string;
    departmentName: string;
    address: string;
    telephoneNumber: string;
}

// Delete department
export const API_DEPARTMENT_DELETE_URL: string = 'http://localhost:8082/department/delete'

export type APIDeleteDepartmentType = {
    accessToken: string;
    value: string;
}